import React from "react";
import AddSubCategory from "../../components/subCategoryes/SubCategoryForm";
import SubCatigoryesList from "../../components/subCategoryes/subcatigoryesList/subCategoriesList";

function SubCategories() {
  return (
    <div>
      <AddSubCategory />
      <SubCatigoryesList />
    </div>
  );
}

export default SubCategories;
